import React from "react";
import { Text, View } from "@react-pdf/renderer";
import { styles } from "../styles";
import { translate } from "../translate";

export const CustomerSignature = ({ order, country }) => {
  const text = country === "Switzerland" ? order.swissInfo : order.germanInfo;

  return (
    <>
      <View style={styles.row}>
        <Text style={styles.blurb}>{text}</Text>
      </View>
      <View style={styles.row}>
        <View style={styles.col60}>
          <Text style={[styles.bold, styles.sigText]}>
            {translate("signature")}
          </Text>
          <View style={styles.signature} />
        </View>
        <View style={styles.col40}>
          <Text style={[styles.bold, styles.sigText]}>
            {translate("signatureDate")}
          </Text>
          <View style={styles.signature} />
        </View>
      </View>
    </>
  );
};
